import { Flex, Icon, Text } from "@chakra-ui/react"
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

type ClassificacoesData = {
	CODCLA: number;
	CODSCL: number;
	nome: string;
};
interface MenuClassifParams {
	classificacoes: ClassificacoesData[];
	selectedClassif: ClassificacoesData;
	setSelectedClassif: (classif: ClassificacoesData) => void;
  setRecoveryClassif: (classif: ClassificacoesData) => void;
	handleSearchClassif: (nome: string) => void;
}

const MenuClassif: React.FC<MenuClassifParams> = ({
	classificacoes,
	selectedClassif,
	setSelectedClassif,
  setRecoveryClassif,
	handleSearchClassif,
}) => {
	function handleMenuScroll(sentido: string) {
		const aux = document.getElementById('menu-class');

		if (aux) {
			if (sentido === 'right') {
				aux.scrollLeft += 300;
			} else {
				aux.scrollLeft -= 300;
			}
		}
	};

	function horizontalScroll(e: any) {
		const container = document.getElementById('menu-class');
		// const containerScrollPosition = document.getElementById('menu-class')?.scrollLeft;
		container?.scrollTo({
			top: 0,
			left: container + e.deltaY,
			// behaviour: 'smooth', // if you want smooth scrolling
		});
	};

	function handleSelectScroll(div: string) {
		const target = document.getElementById(`menu-${div}`);

		target?.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
			inline: 'center',
		});
	};

	return (
		<Flex
			justifyContent="center"
			alignItems="center"
			padding="0 0.5rem"
			position="fixed"
			background="white"
			maxWidth={[`calc(100vw - 10px)`, `calc(100vw - 100px)`]}
		>
			<Text
				as="button"
				onClick={() => handleMenuScroll('left')}
			>
				<Icon
					as={FiChevronLeft}
					fontSize={["20", "28"]}
					color="gray.300"
				/>
			</Text>

			<Flex
				id="menu-class"
				w="auto"
				maxWidth="100%"
				alignItems="center"
				scrollBehavior="smooth"
				m="0 0.5rem"
				p="0.3rem 0"
				overflowX="scroll"
				onWheel={horizontalScroll}
				// maxWidth={`calc${window.screen.width} - 500px`}
				css={{
					'msOverflowStyle': 'none',
    			overflow: '-moz-scrollbars-none',
    			scrollbarWidth: 'none'
				}}
			>
				{classificacoes.map((classif) => {
					return (
						<Flex
							key={classif.nome}
							id={`menu-${classif.nome}`}
							justifyContent="center"
							alignItems="center"
							cursor="pointer"
							padding={["0 0.8rem", "0 0.9rem"]}
						>
							<Text
								as="button"
								fontSize={["0.8rem", "0.9rem"]}
								fontWeight={500}
								color={selectedClassif.nome === classif.nome ? 'blue.500' : '#333'}
								borderBottomWidth={2}
								borderBottomColor={selectedClassif.nome === classif.nome ? 'blue.500' : 'transparent'}
								onClick={() => {
									setSelectedClassif(classif);
                  setRecoveryClassif(classif);
									handleSearchClassif(classif.nome);
									handleSelectScroll(classif.nome);
								}}
							>
								{classif.nome}
							</Text>
						</Flex>
					)
				})}
			</Flex>

			<Text
				as="button"
				onClick={() => handleMenuScroll('right')}
			>
				<Icon
					as={FiChevronRight}
					fontSize={["20", "28"]}
					color="gray.300"
				/>
			</Text>
		</Flex>
	)
}

export default MenuClassif
